<template>
    <div class="convention-body">
        <div v-for="(annotation, index) in annotations" :key="`${annotation.type}-${index}`">
            <annotation-type-text
                v-if="annotation.type === 'text'"
                :annotation="annotation"
                :cspFilters="cspFilters"
            />
            <annotation-type-synchronize
                v-if="annotation.type === 'synchronize'"
                :synchronizedSection="synchronizedSection"
            />
            <annotation-type-insurer
                v-if="annotation.type === 'insurer'"
                :annotation="annotation"
                :insurers="insurers"
                :annotationOptions="annotationOptions"
            />
            <annotation-type-indemnity
                v-if="annotation.type === 'indemnity'"
                :annotation="annotation"
                :annotationOptions="annotationOptions"
            />
            <annotation-type-rates
                v-if="annotation.type === 'rates'"
                :annotation="annotation"
                :annotationOptions="annotationOptions"
            />
            <annotation-type-guarantees-detailed
                v-if="annotation.type === 'guaranteesDetailed'"
                :annotation="annotation"
                :annotationOptions="annotationOptions"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import AnnotationTypeText from "./annotationTypeDisplay/AnnotationTypeText.vue";
import AnnotationTypeSynchronize from "./annotationTypeDisplay/AnnotationTypeSynchronize.vue";
import AnnotationTypeInsurer from "./annotationTypeDisplay/AnnotationTypeInsurer.vue";
import { find } from "lodash";

import contentBody from "src/mixins/contentBody";
import AnnotationTypeIndemnity from "./annotationTypeDisplay/AnnotationTypeIndemnity.vue";
import AnnotationTypeRates from "./annotationTypeDisplay/AnnotationTypeRates.vue";
import AnnotationTypeGuaranteesDetailed from "./annotationTypeDisplay/AnnotationTypeGuaranteesDetailed.vue";

export default Vue.extend({
    components: {
        AnnotationTypeText,
        AnnotationTypeSynchronize,
        AnnotationTypeInsurer,
        AnnotationTypeIndemnity,
        AnnotationTypeRates,
        AnnotationTypeGuaranteesDetailed,
    },
    props: ["annotations", "insurers", "titlePath", "sections", "cspFilters", "annotationOptions"],
    mixins: [contentBody],
    mounted() {
        this.filterContent();
    },
    updated() {
        this.filterContent();
    },
    methods: {
        filterContent() {
            this.normalizeTitles();
            this.normalizeArticleLinks();
            this.normalizeArticlesCategoryLinks();
            this.normalizeCCNLinks(this.mode);
            this.normalizeLinkedContentsLinks();
            this.normalizeTable();
        },
        getSynchronizedSection(sections, titlePathArray) {
            const section = find(sections, section => section.key === titlePathArray[0]);
            titlePathArray.shift();
            return section && titlePathArray.length > 0
                ? this.getSynchronizedSection(section.children, titlePathArray)
                : section;
        },
    },
    computed: {
        synchronizedSection() {
            const titlePathArray = this.titlePath.split("/");
            return this.getSynchronizedSection(this.sections, titlePathArray);
        },
    },
});
</script>

<style lang="sass">
.convention-body
    color: $color-secondary

    ul
        margin: 10px 0 20px 0
        li
            margin: 8px 0

    table
        width: 100%
        margin: 16px 0 16px 0
        border-collapse: collapse
        border-radius: 5px
        display: table
        th
            background: $color-yellow
            color: $color-secondary
            padding: 5px 10px
            border: 1px solid transparentize($color-secondary, 0.4)
        td
            border: 1px solid transparentize($color-secondary, 0.4)
            padding: 5px

    .cc-article
        display: block
        position: relative
        text-align: left
        background: $color-background
        padding: $grid-gutter
        align-items: center
        margin: 16px 0
        padding: 25px 16px 25px 80px
        box-sizing: border-box
        &:before
            top: calc(50% - 25px)
            left: 20px
            position: absolute
            display: block
            content: ''
            width: 50px
            height: 50px
            // background: url(./article.svg) no-repeat
            background-size: contain
            background-position: center

    .cc-inside-h2
        display: block
        position: relative
        margin: 50px 0 30px 0
        padding-bottom: 10px
        &:before
            position: absolute
            width: 50px
            bottom: 0
            content: ""
            height: 1px
            background: $color-secondary

    .cc-inside-h1
        display: block
        position: relative
        margin: 20px 0 30px 0
        padding-bottom: 10px

    .cc-inside-h3
        display: block
        margin: 30px 0 15px 0
        font-size: 18px
        margin: 16px 0
    .cc-inside-h4
        display: block
        margin: 30px 0 10px 0
        font-size: 16px
        margin: 16px 0
    .cc-inside-h5
        display: block
        margin: 30px 0 5px 0
        font-size: 14px
        margin: 16px 0
</style>
